(function () {
  'use strict';

  var config = (window.theme && window.theme.felina) || {};
  var SWATCH_SELECTOR = '.product-swatches-options__item--swatch';
  var SWIPER_SELECTOR = '.product-swatches__wrap.swiper';
  var SCROLL_LIST_SELECTOR = '.product-swatches-options--slider .product-swatches-options__list';

  function getConfig() {
    return {
      enableSlider: config.enableProductCardSwatchSlider !== false,
      enableImageUpdate: config.enableProductCardSwatchImageUpdate !== false
    };
  }

  function getEventElement(event) {
    var target = event && event.target;

    if (!target) return null;

    if (target.nodeType === Node.TEXT_NODE) {
      target = target.parentElement;
    }

    if (!target || typeof target.closest !== 'function') {
      return null;
    }

    return target;
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, window.Shopify.money_format);
    }

    return '$' + (cents / 100).toFixed(2);
  }

  function getProductUrl(swatch) {
    var url = swatch.getAttribute('data-product-url');
    if (!url) return null;

    try {
      return new URL(url, window.location.origin).pathname;
    } catch (e) {
      return url.split('?')[0];
    }
  }

  function setImageSource(wrapper, src) {
    if (!wrapper || !src) return;

    var img = wrapper.querySelector('img');
    if (!img) return;

    img.src = src;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
  }

  function updateProductImages(productItem, product, variant) {
    var imageOne = productItem.querySelector('.product-item__image--one, .product-item__image-link .product-item__image:not(.product-item__image--two)');
    var imageTwo = productItem.querySelector('.product-item__image--two');
    var nextPosition = 0;

    if (variant && variant.featured_image) {
      setImageSource(imageOne, variant.featured_image.src);
      nextPosition = variant.featured_image.position + 1;
    } else if (product.featured_image) {
      setImageSource(imageOne, product.featured_image);
      nextPosition = 2;
    }

    if (!imageTwo) return;

    var secondMedia = null;

    if (Array.isArray(product.media)) {
      product.media.forEach(function (item) {
        if (item.position === nextPosition) {
          secondMedia = item;
        }
      });
    }

    if (secondMedia && secondMedia.src) {
      setImageSource(imageTwo, secondMedia.src);
      imageTwo.classList.remove('active');
    }
  }

  function updateProductPrice(productItem, product, variant) {
    var priceEl = productItem.querySelector('.product-item__price');
    if (!priceEl) return;

    var cents = variant ? variant.price : product.price;
    var formattedPrice = formatMoney(cents);
    var saleEl = priceEl.querySelector('.sale');

    if (saleEl) {
      saleEl.textContent = formattedPrice;
      return;
    }

    var directPrice = priceEl.querySelector(':scope > span:not(.displayed-discount):not(.visually-hidden)');
    if (directPrice) {
      directPrice.textContent = formattedPrice;
    }
  }

  function updateProductLinks(productItem, productUrl, variantId) {
    var href = variantId ? productUrl + '?variant=' + variantId : productUrl;

    productItem.querySelectorAll('a[href*="/products/"]').forEach(function (link) {
      link.setAttribute('href', href);
    });
  }

  function setActiveSwatch(swatch) {
    var list = swatch.closest('.product-swatches-options__list');
    if (!list) return;

    list.querySelectorAll('.active-swatch-item').forEach(function (item) {
      item.classList.remove('active-swatch-item');
      item.setAttribute('aria-checked', 'false');
    });

    swatch.classList.add('active-swatch-item');
    swatch.setAttribute('aria-checked', 'true');
  }

  // Clicking through several swatches on the same card (e.g. checking each
  // color) was re-fetching that product's full .js payload on every single
  // click, with no caching at all. Enough rapid repeat requests to the same
  // /products/X.js endpoint tripped rate limiting (429) on the live store.
  // Cache by productUrl - including the in-flight promise, not just the
  // resolved value - so clicking the same product's swatches only ever
  // fetches it once per page load. A failed fetch clears its cache entry so
  // a later click can retry instead of being stuck failing forever.
  var productJsonCache = {};

  function fetchProductJson(productUrl) {
    if (productJsonCache[productUrl]) {
      return productJsonCache[productUrl];
    }

    var request = fetch(productUrl + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Product fetch failed');
      return response.json();
    }).catch(function (err) {
      delete productJsonCache[productUrl];
      throw err;
    });

    productJsonCache[productUrl] = request;
    return request;
  }

  function handleSwatchActivate(swatch) {
    var cfg = getConfig();
    if (!cfg.enableImageUpdate) return;

    var productItem = swatch.closest('.product-item');
    var productUrl = getProductUrl(swatch);
    if (!productItem || !productUrl) return;

    setActiveSwatch(swatch);

    var variantId = parseInt(swatch.getAttribute('data-variant-id'), 10);
    var isSibling = swatch.hasAttribute('data-sibling-product');

    fetchProductJson(productUrl)
      .then(function (product) {
        var variant = null;

        if (!isSibling && variantId) {
          variant = product.variants.find(function (item) {
            return item.id === variantId;
          });
        }

        updateProductImages(productItem, product, variant);
        updateProductPrice(productItem, product, variant);
        updateProductLinks(productItem, productUrl, variant ? variant.id : null);
      })
      .catch(function () {});
  }

  function onSwatchClick(event) {
    var el = getEventElement(event);
    if (!el) return;

    var swatch = el.closest(SWATCH_SELECTOR);
    if (!swatch || !swatch.closest('.product-item--with-hover-swatches')) return;

    event.preventDefault();
    event.stopPropagation();
    handleSwatchActivate(swatch);
  }

  function onSwatchKeydown(event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;

    var el = getEventElement(event);
    if (!el) return;

    var swatch = el.closest(SWATCH_SELECTOR);
    if (!swatch || !swatch.closest('.product-item--with-hover-swatches')) return;

    event.preventDefault();
    handleSwatchActivate(swatch);
  }

  function enableSwatchSlide() {
    var cfg = getConfig();
    if (!cfg.enableSlider || typeof window.Swiper === 'undefined') return;

    document.querySelectorAll(SWIPER_SELECTOR).forEach(function (el) {
      if (el.swiper) return;

      try {
        new window.Swiper(el, {
          slidesPerView: 'auto',
          grabCursor: true,
          mousewheel: true,
          freeMode: true,
          spaceBetween: 6,
          observer: true,
          observeParents: true,
          // Swiper's a11y module decorates the wrapper with aria-live and the
          // slides with group/slide roles - wrong semantics for what is really
          // a strip of swatch buttons (each already exposes role="button" and
          // an aria-label), and flagged by accessibility scanners.
          a11y: { enabled: false },
          // Swiper's default click-guarding (preventClicks/preventClicksPropagation)
          // stops the click event from ever reaching our delegated document
          // listener whenever it thinks a drag occurred - which, in freeMode,
          // it readily does even for a plain tap. That silently ate every
          // swatch tap on touch devices: the active state never changed and
          // the product image never updated. Swatches are a tap-to-select
          // control first and a swipeable strip second, so let taps through.
          preventClicks: false,
          preventClicksPropagation: false
        });
      } catch (e) {}
    });
  }

  function waitForSwiper(callback, attempts) {
    var remaining = typeof attempts === 'number' ? attempts : 20;

    if (typeof window.Swiper !== 'undefined') {
      callback();
      return;
    }

    if (remaining <= 0) {
      callback();
      return;
    }

    setTimeout(function () {
      waitForSwiper(callback, remaining - 1);
    }, 100);
  }

  function initDragScroll() {
    var isDown = false;
    var startX = 0;
    var scrollLeft = 0;
    var activeSlider = null;

    function getScrollList(target) {
      if (!target || typeof target.closest !== 'function') return null;

      var list = target.closest(SCROLL_LIST_SELECTOR);
      if (!list) return null;

      var swiperEl = list.closest('.swiper');
      if (swiperEl && swiperEl.swiper) return null;

      return list;
    }

    document.addEventListener('mousedown', function (event) {
      var slider = getScrollList(getEventElement(event));
      if (!slider) return;

      isDown = true;
      activeSlider = slider;
      slider.style.cursor = 'grabbing';
      slider.style.userSelect = 'none';
      startX = event.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });

    function stopDragging() {
      if (!activeSlider) return;

      isDown = false;
      activeSlider.style.cursor = 'grab';
      activeSlider.style.userSelect = '';
      activeSlider = null;
    }

    document.addEventListener('mouseleave', stopDragging);
    document.addEventListener('mouseup', stopDragging);

    document.addEventListener('mousemove', function (event) {
      if (!isDown || !activeSlider) return;

      event.preventDefault();
      var x = event.pageX - activeSlider.offsetLeft;
      var walk = (x - startX) * 2;
      activeSlider.scrollLeft = scrollLeft - walk;
    });
  }

  function refresh() {
    waitForSwiper(enableSwatchSlide);
  }

  var refreshTimer = null;
  function scheduleRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refresh, 100);
  }

  function observeCollectionGrid() {
    var collectionGrid = document.querySelector('.collection__infinite-container, .search__infinite-container');
    if (!collectionGrid || typeof MutationObserver === 'undefined') return;

    var observer = new MutationObserver(function () {
      scheduleRefresh();
      if (window.FelinaProductCardLayout && typeof window.FelinaProductCardLayout.refreshMatchHeight === 'function') {
        window.FelinaProductCardLayout.refreshMatchHeight();
      }
    });

    observer.observe(collectionGrid, { childList: true, subtree: true });
  }

  function init() {
    if (!document.querySelector('.product-item--with-hover-swatches')) return;

    document.addEventListener('click', onSwatchClick);
    document.addEventListener('keydown', onSwatchKeydown);
    initDragScroll();
    observeCollectionGrid();
    refresh();

    document.addEventListener('felina:collection-products-added', scheduleRefresh);
    document.addEventListener('collectionScrollRestored', scheduleRefresh);
    document.addEventListener('shopify:section:load', scheduleRefresh);
    window.addEventListener('load', scheduleRefresh);
  }

  window.FelinaProductCardSwatches = {
    refresh: refresh,
    enableSwatchSlide: enableSwatchSlide
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
